<template>
    <div class="row py-2" v-if="profile" v-loading="loading">
        <div class="col-10">
            <button class="btn btn-lg btn-link m-0" @click="toggleShow">{{profile.data.title}}</button>
        </div>
        <div class="col-2">
            <div class="dropdown show float-right p-2">
                <a href="#" data-toggle="dropdown" data-display="static" class="text-black-50 p-1">
                    <i class="fas fa-ellipsis-v"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-right">
                    <a class="dropdown-item" @click="downloadProfileExcel()" v-if="$hasPermission('requests.profiles.export')">Скачать анкету (xlsx)</a>
                    <a class="dropdown-item" @click="downloadProfileCustom()" v-if="$hasPermission('requests.profiles.export')">Скачать анкету (Свой формат)</a>
                    <a class="dropdown-item" @click="downloadProfileZip()" v-if="$hasPermission('requests.profiles.export')">Скачать все файлы (zip)</a>
                </div>
            </div>
        </div>
        <div class="col-12 pb-3 border-top border-bottom" v-if="show">
            <Profile :profile_model="profile_model"/>
        </div>
    </div>
</template>

<script>
    import Profile from "./Profile";
    export default {
        name: "ProfileListItem",
        components: {Profile},
        props: ['profile_model'],
        data: () => ({
            profile: null,
            show: false,
            loading: false,
        }),
        mounted() {
            this.profile = this.profile_model;
        },
        methods: {
            toggleShow() {
                this.show = !this.show;
            },
            downloadProfileExcel() {
                let self = this;
                this.loading = true;

                axios.get('/api/request_profiles/' + this.profile.id + '/export/excel', {
                    responseType: 'arraybuffer',
                })
                    .then(response => {
                        self.loading = false;

                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(new Blob([response.data]));
                        link.setAttribute('download', 'request_profile_' + this.profile.request_id + "_" + this.profile.id + "_" + (new Date).getTime() + '.xlsx');
                        document.body.appendChild(link);
                        link.click()
                    });
            },
            downloadProfileCustom() {
                let self = this;
                this.loading = true;

                axios.get('/api/request_profiles/' + this.profile.id + '/export/custom', {
                    responseType: 'arraybuffer',
                })
                    .then(response => {
                        console.log(response);
                        self.loading = false;
                        let m = /filename=(.*)$/.exec(response.headers['content-disposition']);
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(new Blob([response.data]));
                        link.setAttribute('download', m[1]);
                        document.body.appendChild(link);
                        link.click()
                    })
                    .catch(e => {
                        self.loading = false;
                        if (e.response.status === 404) {
                            self.$message.error({
                                message: 'Нет шаблона',
                                duration: 2000,
                            })
                        }
                    })
            },
            downloadProfileZip() {
                let self = this;
                this.loading = true;

                axios.get('/api/request_profiles/' + this.profile.id + '/export/zip', {
                    responseType: 'arraybuffer',
                })
                    .then(response => {
                        self.loading = false;

                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(new Blob([response.data]));
                        link.setAttribute('download', 'request_profile_' + this.profile.request_id + "_" + this.profile.id + "_" + (new Date).getTime() + '.zip');
                        document.body.appendChild(link);
                        link.click()
                    });
            },
        },
    }
</script>

<style scoped>

</style>
